import octoAva from "../assets/octo-ava.webp";
import octoAva1 from "../assets/octo-ava-1.webp";
import octoAva2 from "../assets/octo-ava-2.webp";
import octoAva3 from "../assets/octo-ava-3.webp";
import octoAva4 from "../assets/octo-ava-4.webp";
import octoAva5 from "../assets/octo-ava-5.webp";
import octoAva6 from "../assets/octo-ava-6.webp";
import octoAva7 from "../assets/octo-ava-7.webp";
import octoAva8 from "../assets/octo-ava-8.webp";
import octoAva9 from "../assets/octo-ava-9.webp";

const avatarOptions = [
  { id: "avatar-1", url: octoAva1 },
  { id: "avatar-2", url: octoAva2 },
  { id: "avatar-3", url: octoAva3 },
  { id: "avatar-4", url: octoAva4 },
  { id: "avatar-5", url: octoAva5 },
  { id: "avatar-6", url: octoAva6 },
  { id: "avatar-7", url: octoAva7 },
  { id: "avatar-8", url: octoAva8 },
  { id: "avatar-9", url: octoAva9 },
  { id: "avatar-10", url: octoAva }
];

export default avatarOptions;

